var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStormTracks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_437_16558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H36C38.2091 0 40 1.79086 40 4V36C40 38.2091 38.2091 40 36 40H4C1.79086 40 0 38.2091 0 36V4Z",
    fill: "#E1E9F1"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_437_16558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2141 29.9448H16.3067H15.2406L16.8664 27.6046C17.1729 27.1698 17.053 26.5687 16.5865 26.2746C16.1334 25.9805 15.5071 26.0956 15.2006 26.5432L12.5354 30.3796C12.3355 30.6738 12.3088 31.0574 12.4821 31.3643C12.6553 31.6712 12.9885 31.8758 13.3616 31.8758H15.4938L13.868 34.2161C13.5615 34.6509 13.6814 35.2519 14.1478 35.5461C14.3211 35.6611 14.5076 35.7123 14.7075 35.7123C15.0274 35.7123 15.3472 35.5588 15.5338 35.2903L18.199 31.4538C18.3989 31.1597 18.4256 30.7761 18.2523 30.4691C18.0791 30.1622 17.7934 29.9448 17.4203 29.9448H17.2141Z",
    fill: "#1C53EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6484 29.7634L11.6484 29.7634L11.6421 29.7726C11.2278 30.3823 11.1527 31.2063 11.5415 31.8952C11.9022 32.5341 12.5906 32.9558 13.3616 32.9558H13.4285L12.9827 33.5974C12.3172 34.5457 12.5941 35.8347 13.5609 36.4527C13.9203 36.6884 14.3138 36.7923 14.7075 36.7923C15.354 36.7923 16.0173 36.4872 16.4207 35.9065L19.086 32.07L19.086 32.0701L19.0922 32.0609C19.5066 31.4512 19.5817 30.6272 19.1928 29.9383C18.8775 29.3795 18.2741 28.8648 17.4203 28.8648H17.3059L17.7516 28.2233C18.4183 27.2734 18.1394 25.9816 17.1686 25.3649C16.2406 24.767 14.959 24.9886 14.3119 25.9294L11.6484 29.7634Z",
    stroke: "white",
    strokeWidth: 2.16,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_437_16558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.8469 29.9448H23.9395H22.8734L24.4992 27.6046C24.8057 27.1698 24.6858 26.5687 24.2193 26.2746C23.7663 25.9805 23.1399 26.0956 22.8334 26.5432L20.1682 30.3796C19.9683 30.6738 19.9416 31.0574 20.1149 31.3643C20.2881 31.6712 20.6213 31.8758 20.9944 31.8758H23.1266L21.5008 34.2161C21.1943 34.6509 21.3142 35.2519 21.7807 35.5461C21.9539 35.6611 22.1405 35.7123 22.3404 35.7123C22.6602 35.7123 22.98 35.5588 23.1666 35.2903L25.8318 31.4538C26.0317 31.1597 26.0584 30.7761 25.8851 30.4691C25.7119 30.1622 25.4263 29.9448 25.0531 29.9448H24.8469Z",
    fill: "#1C53EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2812 29.7634L19.2812 29.7634L19.2749 29.7726C18.8606 30.3823 18.7855 31.2063 19.1744 31.8952C19.535 32.5341 20.2234 32.9558 20.9944 32.9558H21.0613L20.6156 33.5974C19.9501 34.5457 20.2269 35.8347 21.1937 36.4527C21.5531 36.6884 21.9466 36.7923 22.3404 36.7923C22.9868 36.7923 23.6501 36.4872 24.0535 35.9065L26.7188 32.07L26.7188 32.0701L26.7251 32.0609C27.1394 31.4512 27.2145 30.6272 26.8256 29.9383C26.5103 29.3795 25.9069 28.8648 25.0531 28.8648H24.9387L25.3844 28.2233C26.0511 27.2734 25.7722 25.9816 24.8014 25.3649C23.8734 24.767 22.5919 24.9886 21.9448 25.9294L19.2812 29.7634Z",
    stroke: "white",
    strokeWidth: 2.16,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_437_16558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9219 22.3822C9.3125 22.2615 6.42383 19.2932 6.42383 15.6545C6.42383 12.058 9.24453 9.12246 12.7936 8.93613C13.9807 6.1998 16.7064 4.28613 19.8793 4.28613C24.0834 4.28613 27.5029 7.64707 27.5979 11.8283C27.6969 11.8154 27.7965 11.8061 27.8967 11.799C28.0227 11.7896 28.1498 11.785 28.2775 11.785C31.2037 11.785 33.5762 14.1568 33.5762 17.083C33.5762 20.0104 31.2037 22.3822 28.2775 22.3822H13.1516C13.0748 22.3822 12.998 22.3846 12.9219 22.3822Z",
    fill: "#1C53EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8858 23.4616L12.8887 23.4617C12.9636 23.464 13.0643 23.463 13.1187 23.4625C13.1337 23.4623 13.1451 23.4622 13.1516 23.4622H28.2775C31.8002 23.4622 34.6562 20.6068 34.6562 17.083C34.6562 13.6634 31.9649 10.8728 28.5853 10.7123C27.959 6.4656 24.2998 3.20613 19.8793 3.20613C16.4927 3.20613 13.5549 5.11867 12.0838 7.9193C8.27679 8.44034 5.34383 11.7035 5.34383 15.6545C5.34383 19.8766 8.69532 23.3215 12.8858 23.4616ZM27.8211 10.7217C27.8203 10.7217 27.8196 10.7218 27.8188 10.7218C27.818 10.7219 27.8173 10.7219 27.8165 10.722L27.8967 11.799L27.8211 10.7217Z",
    stroke: "white",
    strokeWidth: 2.16,
    strokeLinecap: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_437_16558",
    x: 5.40703,
    y: 19.1531,
    width: 19.9203,
    height: 23.5189,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.504167 0 0 0 0 0.504167 0 0 0 0 0.504167 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_437_16558"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_437_16558",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_437_16558",
    x: 13.0398,
    y: 19.1531,
    width: 19.9203,
    height: 23.5189,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.504167 0 0 0 0 0.504167 0 0 0 0 0.504167 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_437_16558"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_437_16558",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_437_16558",
    x: -0.536328,
    y: -2.67402,
    width: 41.0727,
    height: 32.017,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.504167 0 0 0 0 0.504167 0 0 0 0 0.504167 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_437_16558"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_437_16558",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_437_16558"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H36C38.2091 0 40 1.79086 40 4V36C40 38.2091 38.2091 40 36 40H4C1.79086 40 0 38.2091 0 36V4Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStormTracks);
export default __webpack_public_path__ + "static/media/storm-tracks.cd3aa0b3a5ebc73ab18bebb9a5b5244f.svg";
export { ForwardRef as ReactComponent };